var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxIconCheckedMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2371 1.94106H4.76654C3.20715 1.94106 1.94301 3.2052 1.94301 4.76459V13.2352C1.94301 14.7946 3.20715 16.0587 4.76654 16.0587H13.2371C14.7965 16.0587 16.0607 14.7946 16.0607 13.2352V4.76459C16.0607 3.2052 14.7965 1.94106 13.2371 1.94106ZM4.76654 0.529297C2.42746 0.529297 0.53125 2.4255 0.53125 4.76459V13.2352C0.53125 15.5743 2.42746 17.4705 4.76654 17.4705H13.2371C15.5762 17.4705 17.4724 15.5743 17.4724 13.2352V4.76459C17.4724 2.4255 15.5762 0.529297 13.2371 0.529297H4.76654Z",
    fill: "#BCB1F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0302 6.87538L8.33564 12.6217L3.97656 8.22297L5.48073 6.73236L8.33564 9.61322L12.526 5.38477L14.0302 6.87538Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIconCheckedMobile);
export default __webpack_public_path__ + "static/media/checkbox_icon_checked_mobile.4ca2e5db3562d39f892a1c87bf42de44.svg";
export { ForwardRef as ReactComponent };